import React from 'react';
import {
  Flex,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  ModalFooter,
  List,
  ListItem,
  Button,
  Text,
  Image,
} from '@chakra-ui/react';

export type DemoSiteModalProps = {
  isOpen: boolean;
  onClose: () => void;
  onCreate: () => void;
  isCreating?: boolean;
};

const DemoSiteModal = ({
  isOpen,
  onClose,
  onCreate,
  isCreating = false,
}: DemoSiteModalProps) => (
  <Modal isOpen={isOpen} onClose={onClose} isCentered>
    <ModalOverlay />
    <ModalContent maxW='448px' w='90vw'>
      <ModalHeader px={6} py={4}>
        <Text fontSize='xl' fontWeight='semibold'>
          Create demo site
        </Text>
      </ModalHeader>
      <ModalCloseButton _focus={{ boxShadow: 'none' }} />
      <ModalBody px={6} pt={2} pb={4}>
        <Flex gap={4} align='flex-start'>
          <Image
            src='https://delivery-sitecore.sitecorecontenthub.cloud/api/public/content/spot-rocket-launch'
            w={12}
            h={12}
            flexShrink={0}
          />
          <Flex direction='column' flex={1}>
            <Text
              mb={4}
              fontSize='16px'
              color='gray.700'
              fontWeight='medium'
              lineHeight='short'
            >
              Give your team the playground to experiment with XM Cloud and
              explore possibilities!
            </Text>
            <List spacing={2} as='ul' sx={{ listStyleType: 'disc', pl: 4 }}>
              <ListItem fontSize='14px' color='gray.600' lineHeight='base'>
                Try editing the site with Site Builder
              </ListItem>
              <ListItem fontSize='14px' color='gray.600' lineHeight='base'>
                Check out how you can manage content
              </ListItem>
              <ListItem fontSize='14px' color='gray.600' lineHeight='base'>
                Play around with components in Design Library
              </ListItem>
            </List>
          </Flex>
        </Flex>
      </ModalBody>
      <ModalFooter px={6} py={4}>
        <Button colorScheme='purple' onClick={onCreate} isDisabled={isCreating}>
          Create
        </Button>
      </ModalFooter>
    </ModalContent>
  </Modal>
);

export default React.memo(DemoSiteModal);
